import { Property } from "./property";

export class DeviceTypeViewModel {
	name: string;
	properties: Array<Property>;
}